(function ($) {
    let loading = false;

    function loadPosts(filter = 'upcoming', page = 1, isLoadMore = false) {
        if (loading) return;
        loading = true;

        const containerPosts = $('#post-container-news');
        const spinner = $('#loading-news');

        spinner.addClass('is-visible');

        if (isLoadMore) {
            $('.load-nav').remove();
        } else {
            $('.load-nav').remove();
            containerPosts.empty();
        }

        $.ajax({
            url: MyAjax.ajaxurl,
            type: 'POST',
            data: {
                action: 'load_more_events',
                page: page,
                filter: filter
            },
            success: function (response) {
                loading = false;
                spinner.removeClass('is-visible');

                if (!response || response.trim() === "") {
                    if (!isLoadMore) {
                        containerPosts.html('<p>Постів не знайдено.</p>');
                    }
                    return;
                }

                if (isLoadMore) {
                    containerPosts.append(response);
                } else {
                    containerPosts.html(response);

                    $('html, body').animate({
                        scrollTop: $(".section-events-list").offset().top - 100
                    }, 500);
                }

                const baseUrl = window.location.href.split('/page/')[0].replace(/\/$/, "");
                const newUrl = page > 1 ? `${baseUrl}/page/${page}/` : `${baseUrl}/`;
                history.pushState({}, "", newUrl);

                linksOverride();
            },
            error: function () {
                loading = false;
                spinner.removeClass('is-visible');

                if (!isLoadMore) {
                    containerPosts.html('<p>Сталася помилка. Спробуйте ще раз.</p>');
                }
            }
        });
    }

    $('.section-events-list .tax-name').on('click', function (e) {
        e.preventDefault();

        if (!$(this).hasClass('active')) {
            $('.section-events-list .tax-name').removeClass('active');
            $(this).addClass('active');

            const filter = $(this).data('filter') || 'upcoming';
            loadPosts(filter, 1, false);
        }
    });

    $(document).on('click', '#pagination a.page-numbers', function (e) {
        e.preventDefault();

        const activeFilter = $('.section-events-list .tax-name.active').data('filter') || 'upcoming';
        const href = $(this).attr('href');
        const match = href.match(/\/page\/(\d+)/);
        const targetPage = match ? parseInt(match[1], 10) : 1;

        loadPosts(activeFilter, targetPage, false);
    });

    $(document).on('click', '#load-more-button a', function (e) {
        e.preventDefault();

        const activeFilter = $('.section-events-list .tax-name.active').data('filter') || 'upcoming';
        const match = window.location.href.match(/\/page\/(\d+)/);
        const nextPage = match ? parseInt(match[1], 10) + 1 : 2;

        loadPosts(activeFilter, nextPage, true);
    });

    function linksOverride() {
        $("#pagination a.page-numbers").each(function () {
            const currentHref = $(this).attr("href");
            let pageUrl = window.location.href.split('/page/')[0];
            const newHref = currentHref.replace(/https?:\/\/.*wp-admin\/admin-ajax\.php/, pageUrl);
            $(this).attr("href", newHref);
        });
    }

    function centerActiveCategory() {
        if (window.innerWidth < 1023) {
            const $activeCategory = $('.section-events-list .tax-name.position-center');

            if ($activeCategory.length) {
                const $scrollContainer = $('.section-events-list .wrap-scroll');
                const activeOffsetLeft = $activeCategory[0].offsetLeft;
                const activeWidth = $activeCategory.outerWidth();
                const containerWidth = $scrollContainer.width();
                const scrollPosition = activeOffsetLeft - (containerWidth / 2) + (activeWidth / 2);

                $scrollContainer.animate({ scrollLeft: scrollPosition }, 300, 'swing');
            }
        }
    }

    centerActiveCategory();

    $('.section-events-list .tax-name span').on('click', function (e) {
        e.preventDefault();

        const $parentItem = $(this).parent();
        $parentItem.addClass('position-center').siblings().removeClass('position-center');
        centerActiveCategory();
    });

})(jQuery);